<template>
    <span class="character-counter-wrapper">
        <span class="character-counter-current">{{ current }}</span>
        <span>/</span>
        <span class="character-counter-max">{{ max }}</span>
    </span>
</template>

<script>
import { countCharacters } from '@util';

export default {
    props: {
        max: {
            type: [String, Number],
            required: true,
        },
        str: {
            type: String,
            default: '',
        },
        counter: Function,
    },
    computed: {
        current() {
            return R.compose(
                this.counter || countCharacters,
                R.prop('str')
            )(this);
        },
    },
};
</script>

<style lang="scss" scoped>
.character-counter-wrapper {
    display: inline-flex;
    span {
        font-family: $font-common;
        font-weight: bold;
        font-size: 12px;
        color: $color4;
    }
}
</style>


